//Vendor
import React, { Fragment, useState } from 'react'
import {TextField, Grid} from '@material-ui/core' 
import { Visibility, VisibilityOff} from '@material-ui/icons'
import {useHistory} from 'react-router-dom'
//Css
import '../../../Css/LoginTemplate.scss'



//controller
import {LoginController} from '../../../Controller'



function LoginForm(props){
    const [state, setstate] = useState({
        email:'',
        password:''
    })
    const [validationState, setvalidationState] = useState({
        email:{
            statusError:false,
            message:''
        },
        password:{
            statusError:false,
            message:''
        }
    })
    const [response, setresponse] = useState({})
    const history = useHistory()
    const [visibility, setvisibility] = useState(false)
    const onInputHandle = (event) => {
        const {name, value} = event.target
        setstate(prev=>({
            ...prev,
            [name]:value
        }))  
    }

    const onSubmit = async (event) => {
        event.preventDefault()
        
        if(Validation()){
            props.Loading(true)
            await LoginController(state)
            .then(
                user=>{
                     history.push("/Home")      
                }
            )
            .catch(
                error=>console.log(error)
            )
        }
      
    }

    const showPassword = () => {
        if(visibility) setvisibility(false)
        else setvisibility(true)
       
    }

    const Validation = () => {
        let status = false
        if(state.email.length==0){
            setvalidationState(prev=>({
                ...prev,
                email:{
                    statusError:true,
                    message:"FIll The email"
                }
            }))
        }
        else if(state.password.length==0){
            setvalidationState(prev=>({
                ...prev,
                password:{
                    statusError:true,
                    message:"FIll The password"
                }
            }))
        }
        else{
            status = true
        }
        return status
    }

    return(
        <Fragment>
        
        <div className="descWrapper ">
           <div className="descWrapperTitle">
               <h3>Continue To App</h3>    
           </div>
           <form className="" autoComplete="on" method="POST" onSubmit = {event=> onSubmit(event)}>
               <div className="InputWrapper">
                   <Grid container spacing={1} alignItems="flex-end">
                       
                       <Grid item>
                           <TextField  
                                label="Email" 
                                name="email" 
                                onChange={event => onInputHandle(event)}  
                                error = {validationState.email.statusError}
                                helperText = {validationState.email.message}
                            />
                            
                       </Grid>
                   </Grid>
               </div>
               <div className="InputWrapper">
                   <Grid container spacing={1} alignItems="flex-end">
                       
                       <Grid item> 
                           <TextField  
                                    label="Password" 
                                    type= {visibility == true ? "text" : "password"} 
                                    name="password" 
                                    onChange={event => onInputHandle(event)}
                                    error = {validationState.password.statusError}
                                    helperText = {validationState.password.message}
                                />
                       </Grid>
                       <Grid item onClick={showPassword} >
                           {visibility && <Visibility  style={{fontSize:"20px" }}/>}
                           {!visibility && <VisibilityOff style={{fontSize:"20px"}}/>}
                       </Grid>
                   </Grid>
               </div>
               <div className="buttonWrapper">
                  <div className="buttonLoginWrapper">
                  <button type="button" onClick={event => onSubmit(event)} >Login</button>

                  </div>
                  <p style={{fontSize:"14px", opacity:"0.8", }}>Did'n Have Account?</p>
                  <div className="buttonRegisWrapper">
                       <button type="button" className="registerButton" onClick={props.setTriggeregister}>Register</button>
                       <button type="Submit" className="googleButton" >
                           Continue With Google    
                       </button>
                  </div>
               </div>
           </form>
       </div>
      
   </Fragment>
    )
}

export default LoginForm;